// All the state shared between the initial drop target (/) and the Home (/impose)
// pages.
import { ref, shallowRef } from "vue";
import { MultistepTool } from "./ToolKind";
import { ToolParams } from "./AllParams";

/// The current working set of files.
export const dropBatch = shallowRef<File[]>([]);

export const errorLog = ref<string[]>([]);

/// Import exported steps json file.
export const exportedSteps = shallowRef<File | null>(null);

/// Steps that were imported from the file.
export const importedTools = shallowRef<MultistepTool[]>([]);

export const importedParamsList = shallowRef<ToolParams[]>([]);